import {
  Grid,
  IconButton,
  TableCell,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { FormatListBulleted } from "@material-ui/icons";
import { useTranslations } from "adapters/i18n";
import React from "react";
import {
  COLUMNS_WITHOUT_PORTAL_DATA,
  getStylesForDifferenceDetailedColumnCell,
  PAGE_TYPE,
  TABLE_COLUMNS,
} from "../conciliacaoUtil";

export const ConciliationDetailedTableRowCell = ({
  appValue,
  classes,
  columnId,
  onOpenDetailsModal,
  pageType,
  portalValue,
}) => {
  const hidePortalValue = COLUMNS_WITHOUT_PORTAL_DATA.includes(columnId);
  const showOpenDetailsButton =
    columnId === TABLE_COLUMNS.DIFFERENCE && pageType === PAGE_TYPE.DEFAULT;

  const contentClassMap = {
    [PAGE_TYPE.DEFAULT]: classes.contentForPage,
    [PAGE_TYPE.PRINT]: classes.contentForPrint,
  };

  const contentClass = contentClassMap[pageType];

  return (
    <TableCell align="left" component="th" padding="none" scope="row">
      <Grid container style={{ justifyContent: "center" }} direction="row">
        <div className={classes.contentWrapper}>
          <CellContent
            key={`cell-content-${columnId}-app`}
            className={contentClass}
            columnId={columnId}
            pageType={pageType}
            value={appValue}
          />
          {!hidePortalValue && (
            <CellContent
              key={`cell-content-${columnId}-portal`}
              className={contentClass}
              columnId={columnId}
              pageType={pageType}
              value={portalValue}
            />
          )}
        </div>
        {showOpenDetailsButton && (
          <OpenDetailsButton
            buttonClasses={classes.openDetailsButton}
            iconClasses={classes.openDetailsButtonIcon}
            onClick={onOpenDetailsModal}
          />
        )}
      </Grid>
    </TableCell>
  );
};

const CellContent = ({ className, columnId, pageType, value }) => {
  const textStyle = getStylesForDifferenceDetailedColumnCell({
    columnId,
    pageType,
    value,
  });

  return (
    <Typography className={className} style={textStyle}>
      {value}
    </Typography>
  );
};

const OpenDetailsButton = ({ buttonClasses, iconClasses, onClick }) => {
  const { t } = useTranslations();

  return (
    <Tooltip
      arrow="true"
      placement="top"
      title={t("movements:view-operations-history")}
    >
      <IconButton
        classes={{ root: buttonClasses }}
        disableRipple={true}
        onClick={onClick}
        size="small"
      >
        <FormatListBulleted className={iconClasses} />
      </IconButton>
    </Tooltip>
  );
};

const styles = {
  contentWrapper: {
    width: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  contentForPage: {
    fontFamily: "Roboto",
    fontSize: "13.5px",
    fontWeight: "normal",
    color: "#333333",
    paddingLeft: "8px",
    paddingRight: "8px",
    textAlign: "center",
  },
  contentForPrint: {
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: "normal",
    color: "#333333",
    textAlign: "center",
  },
  openDetailsButton: {
    height: 20,
    width: 20,
    left: 5,
  },
  openDetailsButtonIcon: {
    height: 20,
    width: 20,
    color: "#1F77B4",
  },
};

export default withStyles(styles)(ConciliationDetailedTableRowCell);
